// 2026-09-17：平台栏目改名与超管维护入口共用规则，避免分店改名或历史缓存放行。
export const SYSTEM_MAINTENANCE_PERMISSION = 'system.maintenance'

// 系统功能说明仍由平台维护；系统参数按机构及VIP子项权限控制。
export const isPlatformOnlyAdminFunction = (item: any): boolean => {
  const url = String(item?.functionUrl || '').trim().toLowerCase().split(/[?#]/, 1)[0].replace(/\/+$/, '')
  return String(item?.functionKey || '').trim().toLowerCase() === 'system.functionguides'
    || url === '/system/functionguides'
}

export const isBranchPlatformOnlyFunction = (user: any, item: any): boolean =>
  Number(user?.orgId) !== 1000 && isPlatformOnlyAdminFunction(item)

export const isPlatformSuperAdministrator = (user: any): boolean =>
  Number(user?.orgId) === 1000 && Number(user?.roleId) === 1

export const isPlatformSuperAdminPermission = (key: unknown): boolean =>
  key === 'platform.orgrights' || key === SYSTEM_MAINTENANCE_PERMISSION

export const canManageSystemMaintenance = (user: any, functions: any): boolean =>
  isPlatformSuperAdministrator(user) && Array.isArray(functions)
  && functions.some(item => item?.functionKey === SYSTEM_MAINTENANCE_PERMISSION
    && item.functionType === 'FUNC' && item.disabled !== true && Number(item.disabled || 0) === 0)

export const isRetiredPlatformMenu = (user: any, item: any): boolean =>
  Number(user?.orgId) === 1000 && (item?.functionKey === 'datainit'
    || item?.functionKey === 'platform.datainit' || item?.functionUrl === '/platform/datainit')

export const administrationTitleKey = (title: unknown, orgId: unknown): string => {
  const key = title == null ? '' : String(title)
  if (key === 'system.banner') return 'system.siteNotifications'
  if (Number(orgId) !== 1000) return key
  if (key === 'branchlist') return 'platform.merchants'
  return key
}

// 2026-10-24：分类只保留一个菜单；只有旧授权时保留旧URL，不扩展权限。
export const consolidateCategoryMenus = (items: any[]): any[] => {
  const hasUnified = items.some(item => String(item.functionUrl || '').toLowerCase() === '/system/clothcategory')
  return items.filter(item => !hasUnified || String(item.functionUrl || '').toLowerCase() !== '/system/fabriccategories')
    .map(item => String(item.functionUrl || '').toLowerCase() === '/system/fabriccategories'
      ? {...item, functionName:'商品类别', functionKey:'system.clothCategory'} : item)
}
